export class Status {
    id?: number;
    code?: string;
    name?: string;
    nameEnglish?: string;
    parent?: Status;
    color?: string;
}
